import styled from "styled-components";

export default c => styled(c)`
  margin-bottom: -20px;

  .datepicker {
    padding-left: 8px;
  }
`;



// WEBPACK FOOTER //
// ./src/components/app/history/dashboard/filter/style.js